import { get } from 'lodash-es';
import { useEffect, useState } from 'react';
import { meeting } from '@/models';
import { getwebLocales } from '@/utils/common';
import { Lang } from '@/types/lang';

enum asrLang {
  'zh-CHS' = Lang.zh,
  'en' = Lang.en,
  'ja' = Lang.ja,
}
export const useLanguage = () => {
  const [originLang, setOriginLang] = useState<any>('');
  const [targetLang, setTargetLang] = useState<any>('');
  const curLocale = getwebLocales();

  const getTranslateLanguage = () => {
    API.api.webSubtitleV3.availableLanguages
      .request({ meetingId: window.$meetingId })
      .then((res) => {
        if (res.status === 1) {
          let originLang = get(res, 'data.defaultAsrLanguage.language') as asrLang;
          const targetLang = get(res, 'data.defaultAstTargetLanguage.language') as asrLang;
          setOriginLang(asrLang[originLang]);
          if (originLang === targetLang) {
            setTargetLang(Lang.auto);
          } else {
            setTargetLang(asrLang[targetLang]);
          }
        }
      });
  };

  const enableSwitchLanguage = meeting?.ableAppsMap.WebTranscriptionLanguage;

  useEffect(() => {
    window.$meetingId && getTranslateLanguage();
  }, [window.$meetingId]);

  return {
    getTranslateLanguage,
    originLang: curLocale || originLang,
    targetLang,
    enableSwitchLanguage,
  };
};
